import { formatNumeral } from "@asmbl/shared/utils";

export function UnitCell({ value }: { value: number }): JSX.Element {
  return <>{formatNumeral(value)}</>;
}
